import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState({ status: false });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const regularVerificationRes = await axios.post(
          "https://uplbidet-api.vercel.app/login-verification",
          { isAdmin: false },
          { withCredentials: true }
        );

        const adminVerificationRes = await axios.post(
          "https://uplbidet-api.vercel.app/login-verification",
          { isAdmin: true },
          { withCredentials: true }
        );

        console.log(regularVerificationRes.data.status);
        console.log(adminVerificationRes.data.status);
        console.log("Hello");

        if (
          regularVerificationRes.data.status ||
          adminVerificationRes.data.status
        ) {
          let loginVerificationData;

          if (regularVerificationRes.data.status) {
            loginVerificationData = await regularVerificationRes.data;
          }
          if (adminVerificationRes.data.status) {
            loginVerificationData = await adminVerificationRes.data;
          }

          setLoggedIn(loginVerificationData.status);

          if (loginVerificationData.status) {
            setUser(loginVerificationData);
          }

          console.log(loginVerificationData);
        } else {
          throw new Error("Login verification failed");
        }
      } catch (error) {
        console.error("Error fetching user data: ", error);
      }
    };

    fetchData();
  }, []);

  const logout = async () => {
    try {
      setLoggedIn(false);
      setUser({ status: false });
    } catch (error) {
      console.error("Error during logout: ", error);
    }
  };

  return (
    <AuthContext.Provider value={{ loggedIn, user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export { AuthProvider, useAuth };
